import { useSelector } from 'react-redux';

import { isLoggedInSelector, loggedInStatusSelector } from 'reducers/user';

export const useIsLoggedIn = () => useSelector(isLoggedInSelector);

export const useLoggedInStatus = () => useSelector(loggedInStatusSelector);
